import { render, staticRenderFns } from "./Bulletins.vue?vue&type=template&id=a43332ea&scoped=true"
import script from "./Bulletins.vue?vue&type=script&lang=js"
export * from "./Bulletins.vue?vue&type=script&lang=js"
import style0 from "./Bulletins.vue?vue&type=style&index=0&id=a43332ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43332ea",
  null
  
)

export default component.exports